import { axiosInstance } from "../axios";

export const getVendors = async (userId: string) => {
    try {
        const res = await axiosInstance.get(`/vendors/${userId}`);
        return res.data
    } catch (error) {
        throw (error)
    }
}